module.exports = __webpack_public_path__ + "img/709.0db895b2.png";